// generated by the plop

import { PaginatorModel, PROGRESS_STATUSES } from 'symbols';
import {
  AsteriskEndpoint,
  CallLogModel,
  CONNECT_STATUS_WS,
  ContactModel, DongleStatusEnum,
  ExtensionStatusEnum,
  GpCallMetaModel
} from '../../symbols';
import { SetFavoriteContact } from './gp-asterisk.actions';

export interface GpAsteriskStateModel {
  callList: GpCallMetaModel[];
  connectStatus: CONNECT_STATUS_WS;
  volume: number;
  countConnected: number;
  toCallStatus: PROGRESS_STATUSES;
  loadEndpointStatus: PROGRESS_STATUSES;
  endpoints: AsteriskEndpoint[]
  statusExtension: ExtensionStatusEnum
  isWorkTime: boolean;
  contacts: ContactModel[];
  favoriteContacts: ContactModel[];
  loadContactsStatus: PROGRESS_STATUSES;
  callLogs: PaginatorModel<CallLogModel>
  loadCallLogsStatus: PROGRESS_STATUSES;
  setFavoriteStatusDict: {[contactId: string]: PROGRESS_STATUSES};
  dongleStatus: {device: string, status: DongleStatusEnum}[];
  updateContactStatus: PROGRESS_STATUSES;
}

export const GP_ASTERISK_STATE_DEFAULT: GpAsteriskStateModel = {
  callList: [],
  connectStatus: CONNECT_STATUS_WS.DISCONNECT,
  volume: .5,
  countConnected: 0,
  toCallStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  loadEndpointStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  endpoints: [],
  statusExtension: ExtensionStatusEnum.UNAVAILABLE,
  isWorkTime: true,
  contacts: [],
  favoriteContacts: [],
  loadContactsStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  loadCallLogsStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  updateContactStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  callLogs: {
    data: [],
    links: null,
    meta: null,
  },
  setFavoriteStatusDict: {},
  dongleStatus: []
};
